export const OPERATIONAL_HEALTH_REQUEST = "OPERATIONAL_HEALTH_REQUEST";
export const OPERATIONAL_HEALTH_SUCCESS = "OPERATIONAL_HEALTH_SUCCESS";
export const OPERATIONAL_HEALTH_ERROR = "OPERATIONAL_HEALTH_ERROR";
